import { valueExists } from '@mw/helpers';

import { getPrimus } from '~/utils/primus';
import { MessageType, Origin, CLIENT_ORIGIN_WS_EVENTS } from '~/constants';

import { MESSAGES_CHUNK_SIZE } from '../../constants';

export const fetchMessages = ({ conversationID, searchQuery, offset }) => {
  const primus = getPrimus();

  return primus.emit(CLIENT_ORIGIN_WS_EVENTS.COLLECTION, {
    cid: 'messages',
    filters: {
      customer_id: conversationID,
      ...(searchQuery && {
        'payload.type': { $in: [MessageType.TEXT, MessageType.RESET_KEYBOARD] },
        'payload.text': {
          $regex: searchQuery,
          $options: 'i',
        },
      }),
    },
    sort: 'sent',
    order: -1,
    limit: MESSAGES_CHUNK_SIZE,
    ...(valueExists(offset) && { offset: offset + MESSAGES_CHUNK_SIZE }),
  });
};

export const emitMessage = (payload, conversationID) => {
  const primus = getPrimus();

  const message = {
    customer_id: conversationID,
    origin: Origin.AGENT,
    ...payload,
  };

  primus.emit(CLIENT_ORIGIN_WS_EVENTS.COLLECTION, { cid: 'messages' }, message);
};
